import { LogLevel } from "@azure/msal-browser";
import getCurrentEnv from "../utils/getCurrentEnv";

const getRedirectUri = () => {
  const { origin } = window.location;
  return `${origin}/redirect`;
};

const getMsalConfig = () => {
  const env = getCurrentEnv();

  // TODO: Replace with your actual Azure Entra ID tenant and client IDs per environment
  const configs = {
    dev: {
      clientId: "e94b8a96-d49e-4281-bc06-982a7eeae264",
      tenantId: "eef95730-77bf-4663-a55d-1ddff9335b5b",
    },
    it: {
      clientId: "476c4eab-fe91-46a8-b5ca-520d6b71fdd7",
      tenantId: "eef95730-77bf-4663-a55d-1ddff9335b5b",
    },
    uat: {
      clientId: "532c4a23-9c2e-4947-a06b-be9d3de91f14",
      tenantId: "eef95730-77bf-4663-a55d-1ddff9335b5b",
    },
    prod: {
      clientId: "c53d5f34-5d8d-40b3-bccc-cd87d565ba83",
      tenantId: "eef95730-77bf-4663-a55d-1ddff9335b5b",
    },
  };

  const envConfig = configs[env] || configs["it"];
  if (!envConfig) {
    throw new Error(`MSAL is not configured for environment: ${env}`);
  }

  return {
    auth: {
      clientId: envConfig.clientId,
      authority: `https://login.microsoftonline.com/${envConfig.tenantId}`,
      redirectUri: getRedirectUri(),
      postLogoutRedirectUri: window.location.origin,
      navigateToLoginRequestUrl: false,
    },
    cache: {
      // localStorage is shared across tabs in the same browser, so a new tab
      // sees the same cached account/tokens immediately (acquireTokenSilent)
      // instead of depending on the iframe-based ssoSilent SSO fallback.
      cacheLocation: "localStorage",
      storeAuthStateInCookie: true, // temporary cookie used only during the redirect handshake
    },
    system: {
      loggerOptions: {
        loggerCallback: (level, message, containsPii) => {
          if (containsPii) return;
          switch (level) {
            case LogLevel.Error:
              console.error(message);
              break;
            case LogLevel.Warning:
              console.warn(message);
              break;
            default:
              break;
          }
        },
        logLevel: env === "prod" ? LogLevel.Error : LogLevel.Warning,
      },
    },
  };
};

export const loginRequest = {
  scopes: ["openid", "profile", "email"],
};

// Silent refresh. Same scopes — MSAL uses the cached refresh token to mint
// a fresh id_token. "User.Read" removed: it was fetching a Graph access
// token you never use, and it forces an extra consent surface.
export const tokenRequest = {
  scopes: ["openid", "profile", "email"],
};

export default getMsalConfig;
